import { render, staticRenderFns } from "./QuotationStepProposal.vue?vue&type=template&id=157a4956"
import script from "./QuotationStepProposal.vue?vue&type=script&lang=js"
export * from "./QuotationStepProposal.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepProposal.vue?vue&type=style&index=0&id=157a4956&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports